<!-- =========================================================================================
    File Name: ForgotPassword.vue
    Description: FOrgot Password Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-img">
    <div
      class="vx-col w-4/5 sm:w-4/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center"
    >
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row">
            <div
              class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center"
            >
              <img
                src="@/assets/images/pages/forgot-password.png"
                alt="login"
                class="mx-auto"
              />
            </div>
            <div
              class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg"
            >
              <div class="p-8">
                <div class="vx-card__title mb-8">
                  <h4 class="mb-4">Recover your password</h4>
                  <p>
                    Please enter your email address and we'll send you
                    instructions on how to reset your password.
                  </p>
                  <div v-if="messageRecover">
                    <vs-alert v-if="!errorMessage" color="success">{{
                      messageRecover
                    }}</vs-alert>
                    <vs-alert v-if="errorMessage" color="warning">{{
                      messageRecover
                    }}</vs-alert>
                  </div>
                </div>

                <form @submit.prevent="onSubmit">
                  <vs-input
                    type="email"
                    label-placeholder="Email"
                    v-model="email"
                    class="w-full mb-8"
                    name="email"
                  />
                  <vs-button
                    type="border"
                    to="/pages/login"
                    class="px-4 w-full md:w-auto"
                    >Back To Login</vs-button
                  >
                  <vs-button
                    class="float-right px-4 w-full md:w-auto mt-3 mb-8 md:mt-0 md:mb-0"
                    button="submit"
                    >Recover Password</vs-button
                  >
                </form>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import axios120 from '../../axios120'
export default {
  data() {
    return {
      email: '',
      errorRecover: false,
      messageRecover: ''

    }
  },
  computed: {
    errorMessage() {
      return this.errorRecover
    }

  },

  methods: {

    onSubmit() {
      const formData = {
        email: this.email
      }
      console.log(formData)
      this.$vs.loading()
      axios120.post('/ecommerce/web/auth/forgotPassword', {
        email: formData.email
      })
        .then(res => {
          if (res.status !== 200) {
            this.errorRecover = true
            this.messageRecover = 'Email tidak terdaftar!'
          } else {
            this.errorRecover = false
            this.messageRecover = 'Berhasil reset password silahkan cek email.'
          }
          this.$vs.loading.close()

        })
        .catch(error => {
          console.log(error.response.data)
          this.errorRecover = error
          this.messageRecover = 'Email tidak terdaftar!'
          this.$vs.loading.close()
        })

    }

  }
}
</script>
